import Axios from '@/components/api/axios.js'

//手工上报接口
export default {
	/**
	 * 获取所有手工上报的变量
	 */
	getManualVariable(pageIndex, pageLen, success, failure) {
		Axios.post('/manual/getManualVariable.do', {
			pageIndex,
			pageLen,
		}, success, failure);
	},
	/**
	 * 手动上传卡特数据
	 */
	uploadKateData(type,time,success,failure) {
		Axios.post('/kate/manualUpload.do', {
			type,
			time
		},success,failure)
	}



}